import {Routes} from "@angular/router";

import {LoginComponent} from "./pages/login/login.component";
import {authGuard} from "src/app/guards/auth.guard";
import {loggedGuard} from "src/app/guards/logged.guard";
import {SignupComponent} from "./pages/signup/signup.component";
import {ResetPasswordComponent} from "./pages/reset-password/reset-password.component";
import {AccountCreatedComponent} from "./pages/account-created/account-created.component";
import {AccountActivationComponent} from "./pages/account-activation/account-activation.component";
import {ForgottenPasswordComponent} from "./pages/forgotten-password/forgotten-password.component";
import {CompleteLegalSignupComponent} from "./pages/complete-legal-signup/complete-legal-signup.component";

export const authenticationRoutes: Routes = [
  {
    path: "email-change",
    loadComponent: () =>
      import("./pages/email-change/email-change.component").then(
        (m) => m.EmailChangeComponent
      ),
  },
  {
    path: "complete-signup",
    component: CompleteLegalSignupComponent,
    canActivate: [loggedGuard],
  },
  {
    path: "login",
    component: LoginComponent,
    canActivate: [authGuard],
  },
  {
    path: "signup",
    component: SignupComponent,
    canActivate: [authGuard],
  },
  {
    path: "forgotten-password",
    component: ForgottenPasswordComponent,
    canActivate: [authGuard],
  },
  {
    path: "reset-password",
    component: ResetPasswordComponent,
    canActivate: [authGuard],
  },
  {
    path: "reset-password/:token",
    component: ResetPasswordComponent,
    canActivate: [authGuard],
  },
  {
    path: "account-created",
    component: AccountCreatedComponent,
    canActivate: [authGuard],
  },
  {
    path: "account-activation",
    component: AccountActivationComponent,
    canActivate: [authGuard],
  },
  {
    path: "account-activation/:token",
    component: AccountActivationComponent,
    canActivate: [authGuard],
  },
];
